import { SettingsIcon, EyeIcon, EditIcon, ArrowLeftIcon } from '@shared/assets/icons';
import { colors } from '@shared/tokens/colors.stylex';
import { VIEW_TYPE } from '@entities/leadCollector';
import { useState, useRef, useEffect } from 'react';
import { Button } from '@shared/ui/kit';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface FormTemplateHeaderProps {
  onBack?: () => void;
  formName?: string;
  onChangeFormName: (formName: string) => void;
  onPreviewTemplate: (viewType: number) => void;
  isDisabledActions: boolean;
  onSaveForm?: () => void;
  setIsOpenSetting: (isOpenSetting: boolean) => void;
}

export const FormTemplateHeader = ({
  onBack,
  formName,
  onChangeFormName,
  onPreviewTemplate,
  isDisabledActions,
  onSaveForm,
  setIsOpenSetting,
}: FormTemplateHeaderProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!isEditing || !inputRef.current) {
      return;
    }
    inputRef.current.focus();
  }, [isEditing]);

  const renderTitle = () => {
    if (isEditing) {
      return (
        <input
          ref={inputRef}
          {...stylex.props(styles.titleInput)}
          value={formName}
          onChange={(e) => onChangeFormName(e.target.value)}
          onBlur={() => setIsEditing(false)}
        />
      );
    }
    return <h2 {...stylex.props(styles.title)}>{formName}</h2>;
  };

  return (
    <div {...stylex.props(styles.container)}>
      <button type="button" {...stylex.props(styles.backButton)} onClick={onBack}>
        <ArrowLeftIcon />К списку шаблонов
      </button>

      <div {...stylex.props(styles.headerRow)}>
        <div {...stylex.props(styles.titleContainer)}>
          {renderTitle()}

          {!isEditing && (
            <button
              type="button"
              {...stylex.props(styles.editIcon)}
              onClick={() => setIsEditing(true)}
              aria-label="Редактировать название шаблона"
            >
              <EditIcon />
            </button>
          )}
        </div>

        <div {...stylex.props(styles.buttonsContainer)}>
          <Button
            size="small"
            variant="secondary"
            settings={{ width: '36px', height: '36px' }}
            onClick={() => setIsOpenSetting(true)}
          >
            <SettingsIcon color={colors.primaryIcon} width="20" height="20" />
          </Button>

          <Button
            size="small"
            variant="secondary"
            isDisabled={isDisabledActions}
            settings={{ width: '36px', height: '36px' }}
            onClick={() => onPreviewTemplate(VIEW_TYPE.PREVIEW_CONSTRUCTOR)}
          >
            <EyeIcon color="currentColor" width="19" height="20" />
          </Button>

          <Button
            size="small"
            variant="primary"
            settings={{ padding: '8px 20px', fontSize: '14px' }}
            onClick={onSaveForm}
            isDisabled={isDisabledActions}
          >
            Сохранить изменения
          </Button>
        </div>
      </div>
    </div>
  );
};
